
export function createQueryBuilderGroup(input) {
	if (!input.type) {
		input.type = "and";
	}
	return {
		logicalOperator: input.type == "and" ? "all" : input.type == "or" ? "any" : null,
		children: (input.parts || []).map(part => createQueryBuilderItem(part))
	};
}

function createQueryBuilderItem(input) {
	if (input.type) {
		return {query: createQueryBuilderGroup(input), type: "query-builder-group"};
	}
	else if (input.cond) {
		return createQueryBuilderRule(input);
	}
}

function createQueryBuilderRule(input) {
	return {type: "query-builder-rule", query: {rule: input.field, value: input.should, operator: input.cond}};
}

function formatQueryBuilderItem(input) {
	if (input.type == "query-builder-group") {
		return formatQueryBuilderGroup(input.query);
	}
	else if (input.type == "query-builder-rule") {
		return formatQueryBuilderRule(input.query);
	}
}

export function formatQueryBuilderGroup(query) {
	if (!query) {
		console.trace("query is undefined");
	}
	return {
		type: query.logicalOperator == "any" ? "or" : query.logicalOperator == "all" ? "and" : null,
		parts: query.children.map(child => formatQueryBuilderItem(child))
	};
}

function formatQueryBuilderRule(query) {
	return {cond: query.operator, field: query.rule, should: query.value};
}

export function queryToString(input, wrap = false) {
	if (!input) {
		return "";
	}
	if (input.type) {
		return groupToString(input, wrap);
	}
	else if (input.cond) {
		return operatorToString(input);
	}
}

function operatorToString(operator) {
	return `${operator.field} ${operator.cond} ${operator.should}`;
}

function groupToString(group, wrap) {
	let joinSign = group.type == "and" ? "&&" : group.type == "or" ? "||" : null;
	let asString = group.parts.map(part => queryToString(part, true)).join(" " + joinSign + " ");
	if (wrap) {
		asString = "(" + asString + ")";
	}
	return asString;
}
